import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M23.395 20 33.65 9.744l2.115-2.115a.8.8 0 0 0 0-1.13l-2.263-2.264a.8.8 0 0 0-1.131 0L20 16.606 7.63 4.234a.8.8 0 0 0-1.132 0L4.234 6.497a.8.8 0 0 0 0 1.131L16.606 20 4.234 32.373a.8.8 0 0 0 0 1.13l2.263 2.264a.8.8 0 0 0 1.131 0L20 23.395 30.258 33.65l2.115 2.115a.8.8 0 0 0 1.13 0l2.264-2.263a.8.8 0 0 0 0-1.131L23.395 20Z" })
});
export default SvgClose;
